module.exports = __webpack_public_path__ + "img/logo.b34f14f8.png";